import { render } from "./UEImageEditView.vue?vue&type=template&id=00071653&scoped=true"
import script from "./UEImageEditView.vue?vue&type=script&lang=js"
export * from "./UEImageEditView.vue?vue&type=script&lang=js"

import "./UEImageEditView.vue?vue&type=style&index=0&id=00071653&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00071653"]])

export default __exports__